import React, { Component } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Button, Card, Table, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { config } from './config'
import { deleteCredentials, getCredentials } from './utils'
import { SEOHeaders } from "./SeoHeaders"
import { BsThreeDotsVertical } from "react-icons/bs"
import { GrFormClose } from "react-icons/gr"
import Dropdown from 'react-bootstrap/Dropdown'

import './Dash.scss'

interface DashProps {
  navigate: any
}

type DashStates = {
  isLoading: boolean
  search: string
  plans: any[]
  user: any
  error: string
  errors: any
  name: string
  description: string
  showModal: boolean
  showEditModal: string
}

class Dash extends Component <DashProps, DashStates> {
  constructor (props: DashProps) {
    super(props)
    this.state = {
      isLoading: false,
      search: '',
      plans: [],
      user: undefined,
      error: '',
      errors: {},
      name: '',
      description: '',
      showModal: false,
      showEditModal: ''
    }
  }

  componentDidMount () {
    this.loadPlans()
  }

  inputChange = (event: any) => {
    if (event.currentTarget.name === "search") {
      this.setState({ [event.currentTarget.name]: event.currentTarget.value } as DashStates, () => this.loadPlans())
    } else {
      this.setState({ [event.currentTarget.name]: event.currentTarget.value } as DashStates)
    }
  }

  loadPlans = () => {
    const { token } = getCredentials()
    const search = this.state.search.length > 0 ? '?search=' + this.state.search : ''
    fetch(
      config.app.apiUri + '/api/v1/plans' + search, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        }
      })
      .then((response) => { return response.json() })
      .then((json) => {
        if (json.status === 'success') {
          this.setState({
            plans: json.plans,
            user: json.user
          })
        }
        if (json.status === 'nopay') {
          this.props.navigate('/payment')
        }
        if (json.status === 'nouser') {
          deleteCredentials()
          this.props.navigate('/signin')
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  create = () => {
    const { token } = getCredentials()
    fetch(
      config.app.apiUri + '/api/v1/plans', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify({
          name: this.state.name,
          description: this.state.description,
          data: {}
        })
      })
      .then((response) => { return response.json() })
      .then((json) => {
        if (json.status === 'success') {
          this.props.navigate('/p/'+json.id)
        }
        if (json.status === 'nopay') {
          this.props.navigate('/payment')
        }
        if (json.status === 'nouser') {
          deleteCredentials()
          this.props.navigate('/signin')
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  openModal = () => {
    this.setState({
      error: '',
      showModal: true
    })
  }

  closeModal = () => {
    this.setState({
      error: '',
      showModal: false
    })
  }

  save = () => {
    const { token } = getCredentials()
    const plan: any = this.state.plans.find((el: any) => el.id === this.state.showEditModal)
    fetch(
      config.app.apiUri + '/api/v1/plans/'+plan.id, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify({
          name: this.state.name,
          description: this.state.description,
          data: plan.data,
          image: plan.image
        })
      })
      .then((response) => { return response.json() })
      .then((json) => {
        if (json.status === 'success') {
          this.closeEditModal()
          this.loadPlans()
        }
        if (json.status === 'nopay') {
          this.props.navigate('/payment')
        }
        if (json.status === 'nouser') {
          deleteCredentials()
          this.props.navigate('/signin')
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  renamePlan = (id: string) => {
    const plan: any = this.state.plans.find((el: any) => el.id === id)
    this.setState({
      error: '',
      showEditModal: id,
      name: plan.name,
      description: plan.description
    })
  }

  closeEditModal = () => {
    this.setState({
      error: '',
      showEditModal: '',
      name: '',
      description: ''
    })
  }

  handleImgError = (e: any) => {
    e.target.src = "data:image/png;base64,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";
  }

  deletePlan = (id: string) => {
    const { token } = getCredentials()
    fetch(
      config.app.apiUri + '/api/v1/plans/'+id, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        }
      })
      .then((response) => { return response.json() })
      .then((json) => {
        if (json.status === 'success') {
          this.loadPlans()
        }
        if (json.status === 'nopay') {
          this.props.navigate('/payment')
        }
        if (json.status === 'nouser') {
          deleteCredentials()
          this.props.navigate('/signin')
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  duplicatePlan = (id: string) => {
    const { token } = getCredentials()
    fetch(
      config.app.apiUri + '/api/v1/plans/'+id+'/duplicate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        }
      })
      .then((response) => { return response.json() })
      .then((json) => {
        if (json.status === 'success') {
          this.loadPlans()
        }
        if (json.status === 'nopay') {
          this.props.navigate('/payment')
        }
        if (json.status === 'nouser') {
          deleteCredentials()
          this.props.navigate('/signin')
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  render() {
    return (
      <div className="h-100 bg-light">
        <SEOHeaders title={'Dashboard'} appendTitle/>
        <div>

          <nav className="bg-white navbar navbar-expand-lg navbar-light py-lg-1 fw-light text-secondary border-bottom"> 
            <div className="container">
              <Link className="fw-bold navbar-brand text-primary" to={"/"}>Modelr</Link> 
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation"> <span className="navbar-toggler-icon"></span></button>   
              <div className="collapse navbar-collapse" id="navbarNavDropdown"> 
                <ul className="navbar-nav me-auto">
                  <li className="nav-item">
                    <a className="nav-link px-lg-3 py-lg-3" href={"/#about"}>About</a> 
                  </li>
                  <li className="nav-item">
                    <a className="nav-link px-lg-3 py-lg-3" href={"/#features"}>Features</a> 
                  </li>
                  <li className="nav-item">
                    <a className="nav-link px-lg-3 py-lg-3" href={"/#pricing"}>Pricing</a> 
                  </li>
                </ul>
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item">
                    <Link className="nav-link px-lg-3 py-lg-3" to={"/community"}>Community</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link px-lg-3 py-lg-3" to={''} onClick={()=>{
                      deleteCredentials()
                      this.props.navigate('/')
                    }}>Sign out</Link>
                  </li>
                </ul>
              </div>
            </div>             
          </nav>

          <div className="container d-flex justify-content-between pb-3 pt-4">
            <h3 className="fw-normal text-dark mb-0">Models</h3>
            <div className="d-flex flex-row">
              <div className="position-relative">
                <input style={{width: 200}} onChange={this.inputChange} value={this.state.search} name="search" type="text" className="form-control shadow-none me-2" placeholder="Search"/>
                {this.state.search.length > 0 ? <GrFormClose size={18} className="position-absolute pointer" role="button" style={{top: 10, right: 18}} onClick={()=>this.setState({search: ''},()=>this.loadPlans())}/> : null}
              </div>
              <button className="btn btn-primary" onClick={()=>this.setState({showModal: true})}>New Model</button>
            </div>
          </div>

          <div className="container">

            <div className="d-flex flex-row flex-wrap row gx-3">

              { this.state.plans.length === 0 && this.state.search === "" ? 
                <div className="d-flex justify-content-center pt-5 text-muted">
                  No models yet
                </div>
              : null}

              { this.state.plans.length === 0 && this.state.search !== "" ? 
                <div className="d-flex justify-content-center pt-5 text-muted">
                  No models found
                </div>
              : null}

              {this.state.plans.map((plan:any) => {
                return <div key={plan.id} className="col-xxl-3 col-lg-3 col-md-6 col-xs-12 pb-3"><div className="card" style={{cursor: 'pointer'}}>
                  <img src={plan.image} onClick={()=>this.props.navigate('/p/'+plan.id)} className="card-img-top" alt="..." onError={this.handleImgError}/>
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                      <h5 onClick={()=>this.props.navigate('/p/'+plan.id)} className="card-title fw-normal text-truncate">{plan.name}</h5>
                      <Dropdown>
                        <Dropdown.Toggle className="dropdown-toggle-hidden p-0 m-0 bg-transparent text-black border-0">
                          <BsThreeDotsVertical className="pe-1 fs-5"/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={()=>this.duplicatePlan(plan.id)}>Duplicate</Dropdown.Item>
                          <Dropdown.Item onClick={()=>this.renamePlan(plan.id)}>Edit</Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item onClick={()=>this.deletePlan(plan.id)}>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <p onClick={()=>this.props.navigate('/p/'+plan.id)} className="card-text text-truncate fw-normal link-secondary">{plan.description}</p>
                  </div>
                </div></div>
              })}

            </div>

          </div>

        </div>

        <Modal show={this.state.showModal} onHide={this.closeModal} animation={false} centered>
          <Modal.Header style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <Modal.Title>New Model</Modal.Title>
          </Modal.Header>
          <Modal.Body> 
            <form className="ps-3 pe-3">
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input className="form-control form-control" name="name" value={this.state.name} onChange={this.inputChange} type="text" placeholder="Name"/>
              </div>
              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control form-control"
                  rows={3}
                  value={this.state.description}
                  name="description"
                  placeholder="Longer description describing your plan"
                  onChange={this.inputChange}
                ></textarea>
              </div>
              { this.state.error !== ''
                ? <div className="alert alert-danger alerterror">
                  {this.state.error}
                </div>
                : null
              }
            </form>
            { this.state.isLoading ?
              <div className="mb-1 text-center">
                <Button className="btn btn-primary account-button" type="button">
                  <div className="spinner-border spinner-border-sm">
                    <span className="sr-only"></span>
                  </div>
                </Button>
              </div>
            :
              <div className="mb-1 text-center">
                <Button className="btn btn-primary account-button" type="submit" onClick={()=>this.create()}>Create</Button>
              </div>
            }
          </Modal.Body>
        </Modal>

        <Modal show={this.state.showEditModal !== ''} onHide={this.closeEditModal} animation={false} centered>
          <Modal.Header style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <Modal.Title>Edit Model</Modal.Title>
          </Modal.Header>
          <Modal.Body> 
            <form className="ps-3 pe-3">
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input className="form-control form-control" name="name" value={this.state.name} onChange={this.inputChange} type="text" placeholder="Name"/>
              </div>
              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control form-control"
                  rows={3}
                  value={this.state.description}
                  name="description"
                  placeholder="Longer description describing your plan"
                  onChange={this.inputChange}
                ></textarea>
              </div>
              { this.state.error !== ''
                ? <div className="alert alert-danger alerterror">
                  {this.state.error}
                </div>
                : null
              }
            </form>
            { this.state.isLoading ?
              <div className="mb-1 text-center">
                <Button className="btn btn-primary account-button" type="button">
                  <div className="spinner-border spinner-border-sm">
                    <span className="sr-only"></span>
                  </div>
                </Button>
              </div>
            :
              <div className="mb-1 text-center">
                <Button className="btn btn-primary account-button" type="submit" onClick={()=>this.save()}>Save</Button>
              </div>
            }
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

export default function DashWithNavigation() {
  const navigate = useNavigate()
  return <Dash navigate={navigate}/>
}